<ng-container *ngIf="{ atLeftEnd: menubarScrollService.atLeftEnd$ | async, atRightEnd: menubarScrollService.atRightEnd$ | async } as data">
    <ng-container [ngTemplateOutlet]="layoutService.isMobile() ? mobileButtons : default" [ngTemplateOutletContext]="{ data }">
    </ng-container>
</ng-container>

<ng-template #default let-data="data">
    <button
        id="btn-menubar-scroll-left"
        class="menu-scroll menu-scroll--left"
        (click)="!data.atLeftEnd && menubarScrollService.doLeft()"
        (mouseover)="menubarScrollService.moveLeft(menuName)"
        (mouseout)="menubarScrollService.clearMove()"
        [ngClass]="{ disabled: data.atLeftEnd }">
        <i
            [ngClass]="{
                'icon-ic-sec-nav-left-none-s1': data.atLeftEnd,
                'icon-ic-sec-nav-left-more-s1': !data.atLeftEnd,
            }"></i>
    </button>
    <button
        id="btn-menubar-scroll-right"
        class="menu-scroll menu-scroll--right"
        [class.quote-button-enabled]="isNewQuoteButtonEnabled"
        (click)="!data.atRightEnd && menubarScrollService.doRight()"
        (mouseover)="menubarScrollService.moveRight(menuName)"
        (mouseout)="menubarScrollService.clearMove()"
        [ngClass]="{ disabled: data.atRightEnd }">
        <i
            [ngClass]="{
                'icon-ic-sec-nav-right-none-s1': data.atRightEnd,
                'icon-ic-sec-nav-right-more-s1': !data.atRightEnd,
            }"></i>
    </button>
</ng-template>

<ng-template #mobileButtons let-data="data">
    <button
        id="btn-menubar-scroll-left-mob"
        class="menu-scroll menu-scroll--left"
        (click)="menubarScrollService.doLeftMobile()"
        [ngClass]="{ disabled: data.atLeftEnd }">
        <i [ngClass]="{ 'icon-ic-sec-nav-left-none-s1': data.atLeftEnd, 'icon-ic-sec-nav-left-more-s1': !data.atLeftEnd }"></i>
    </button>
    <button
        id="btn-menubar-scroll-right-mob"
        class="menu-scroll menu-scroll--right"
        (click)="menubarScrollService.doRightMobile(menuName)"
        [ngClass]="{ disabled: data.atRightEnd }">
        <i [ngClass]="{ 'icon-ic-sec-nav-right-none-s1': data.atRightEnd, 'icon-ic-sec-nav-right-more-s1': !data.atRightEnd }"></i>
    </button>
</ng-template>
